Object.defineProperty(exports, "__esModule", {
    value: true
});
var _class_call_check = require("@swc/helpers/_/_class_call_check");
var _create_class = require("@swc/helpers/_/_create_class");
var _to_consumable_array = require("@swc/helpers/_/_to_consumable_array");
//#region src/utils/hooks/syncHook.ts
var SyncHook = /*#__PURE__*/ function() {
    "use strict";
    function SyncHook(type) {
        _class_call_check._(this, SyncHook);
        this.type = "";
        this.listeners = /* @__PURE__ */ new Set();
        if (type) this.type = type;
    }
    _create_class._(SyncHook, [
        {
            key: "on",
            value: function on(fn) {
                if (typeof fn === "function") this.listeners.add(fn);
            }
        },
        {
            key: "once",
            value: function once(fn) {
                var self = this;
                this.on(function wrapper() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                        args[_key] = arguments[_key];
                    }
                    self.remove(wrapper);
                    return fn.apply(null, args);
                });
            }
        },
        {
            key: "emit",
            value: function emit() {
                for(var _len = arguments.length, data = new Array(_len), _key = 0; _key < _len; _key++){
                    data[_key] = arguments[_key];
                }
                var result;
                if (this.listeners.size > 0) this.listeners.forEach((fn)=>{
                    result = fn.apply(void 0, _to_consumable_array._(data));
                });
                return result;
            }
        },
        {
            key: "remove",
            value: function remove(fn) {
                this.listeners.delete(fn);
            }
        },
        {
            key: "removeAll",
            value: function removeAll() {
                this.listeners.clear();
            }
        }
    ]);
    return SyncHook;
}();
//#endregion
exports.SyncHook = SyncHook; //# sourceMappingURL=syncHook.cjs.map
